import React from "react";

/** Full-bleed auth backdrop: black with brand-blue glow at the bottom. */
const AuthPageBackground: React.FC = () => (
  <div
    aria-hidden
    className="absolute inset-0 -z-10"
    style={{
      backgroundColor: "#000000",
      backgroundImage:
        "radial-gradient(ellipse 90% 55% at 50% 100%, rgba(37, 99, 235, 0.45) 0%, rgba(29, 78, 216, 0.18) 35%, transparent 70%)",
    }}
  />
);

export default AuthPageBackground;
